'use client';

import { create } from 'zustand';

interface SearchState {
  globalSearch: string;
  setGlobalSearch: (search: string) => void;
  clearSearch: () => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  globalSearch: '',
  setGlobalSearch: (search) => set({ globalSearch: search }),
  clearSearch: () => set({ globalSearch: '' }),
}));
